import React, { Component } from 'react';
import { Modal, Button, Input, Divider, Spin, message } from 'antd';
import ReactMarkdown from 'react-markdown';
import { saveAIResult } from "@/request/api";

import ReactDOMServer from 'react-dom/server';
import { requestErrorLog } from "../../../common/util";
import downloadPDF from '@/common/downloadPDF'
import "./styles/deepSeekModal.scss";
const { TextArea } = Input;

class DeepSeekModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            AIRequestType: 3,//0:请求中；1：请求成功；2：请求失败;3：已有结果不用请求
            controller: null,
            visiblePaintPage: false
        }
        this.paintRef = React.createRef();
    }
    componentDidMount() {
        const { deepSeekModalPatientPart, deepSeekModalType } = this.props
        let aaa = deepSeekModalPatientPart.CONCLUSIONS.replace(/\r\n/g, '\n')
        this.setState({
            aaa
        })
        if (deepSeekModalType === 0) {
            if (deepSeekModalPatientPart.AI_INTERPRETATION) {
                this.setState({
                    AIRequestType: 3
                })
            } else {
                this.setState({
                    AIRequestType: 0
                }, () => {
                    //请求ai
                    this.callDeepSeekAPI(deepSeekModalPatientPart.CONCLUSIONS + '。请根据上述报告结论给出报告解读', 0)
                })
            }
        } else {
            if (deepSeekModalPatientPart.AI_EXAM_SUGGEST) {
                this.setState({
                    AIRequestType: 3
                })
            } else {
                this.setState({
                    AIRequestType: 0
                }, () => {
                    //请求ai
                    this.callDeepSeekAPI(deepSeekModalPatientPart.CONCLUSIONS + '。我是基层医疗机构医生，请帮我解读上述报告结论，给予基层医疗机构诊疗建议，并写明参考来源', 1)
                })
            }
        }
        setTimeout(() => {
            if (this.state.AIRequestType === 3) {
                this.openPaintPage()
            }
        }, 1000);

    }

    callDeepSeekAPI = async (inputData) => {
        this.setState({
            controller: new AbortController()
        }, async () => {
            const signal = this.state.controller.signal;
            const url = 'https://api.deepseek.com/v1/chat/completions';
            const apiKey = 'sk-ba74e191f5cb445d9a1592664466b05a'; // 注意：不要在前端硬编码API Key！

            const data = {
                model: "deepseek-chat",
                messages: [
                    { role: "system", content: "You are a helpful assistant." },
                    { role: "user", content: inputData }
                ],
                stream: true,
                temperature: 1.0
            };
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiKey}` // 注意：不要在前端硬编码API Key！
                    },
                    body: JSON.stringify(data),
                    signal
                });
                const reader = response.body.getReader();
                const decoder = new TextDecoder();
                let contentAnswer = '';
                while (true) {
                    const { done, value } = await reader.read();
                    if (done) break;

                    const chunk = decoder.decode(value);
                    this.setState({
                        AIRequestType: 1
                        // eslint-disable-next-line no-loop-func
                    }, () => {
                        chunk.split('\n\n').forEach(event => {
                            if (event.startsWith('data:')) {
                                if (event === 'data: [DONE]') {
                                    //解读完成存入数据库
                                    this.saveDataToServe(contentAnswer)
                                    return;
                                }
                                const data = JSON.parse(event.replace('data:', ''));
                                if (data.choices.length !== 0) {
                                    contentAnswer += data.choices[0].delta.content;
                                    const html = ReactDOMServer.renderToString(<ReactMarkdown>{contentAnswer}</ReactMarkdown>);
                                    document.getElementById('responseWrite').innerHTML = html;
                                }

                            }
                        });
                    })
                }
                if (!response.ok) {
                    this.setState({
                        AIRequestType: 2
                    })
                    throw new Error(`HTTP error! status: ${response.status}`);

                }
            } catch (error) {
                this.setState({
                    AIRequestType: 2
                })
                console.error('Error:', error);
            }
        })
    }

    saveDataToServe = (contentAnswer) => {
        //后端存入字段
        const { deepSeekModalPatientPart, deepSeekModalType } = this.props
        if (deepSeekModalType === 0) {//解读
            let param = {
                Type: "SaveInterpretationResult",
                EXAM_UID: deepSeekModalPatientPart.EXAM_UID,
                AI_INTERPRETATION: contentAnswer,
            }
            saveAIResult(param).then((res) => {
                if (res && res.Status === 1) {
                    if (res.Result === -1) {
                        console.log('ai解读结果存入失败')
                    } else {
                        console.log('ai解读结果存入成功')
                        //存入成功代表可以打印，否则不能打印
                        this.setState({
                            AIRequestType: 3,
                            contentAnswer,
                        }, () => {
                            setTimeout(() => {
                                this.openPaintPage()
                            }, 1000);
                        })
                    }
                } else {
                    requestErrorLog("", "ai解读录入失败", 0, true);
                }
            })

        } else {//建议
            let param = {
                Type: "SaveSuggestResult",
                EXAM_UID: deepSeekModalPatientPart.EXAM_UID,
                AI_EXAM_SUGGEST: contentAnswer,
            }
            saveAIResult(param).then((res) => {
                if (res && res.Status === 1) {
                    if (res.Result === -1) {
                        console.log('ai建议结果存入失败')
                    } else {
                        //存入成功代表可以打印，否则不能打印
                        this.setState({
                            AIRequestType: 3,
                            contentAnswer,
                        }, () => {
                            setTimeout(() => {
                                this.openPaintPage()
                            }, 1000);
                        })
                        console.log('ai建议结果存入成功')
                    }
                } else {
                    requestErrorLog("", "ai建议录入失败", 0, true);
                }
            })
        }
    }
    handleCancel = () => { // 关闭弹框
        if (this.state.controller) {
            this.state.controller.abort();
        }
        this.setState({
            controller: null,

        }, () => {
            this.props.onRef(false);
        })
    }

    tryAgain = () => {
        this.setState({
            AIRequestType: 0
        }, () => {
            const { deepSeekModalPatientPart, deepSeekModalType } = this.props
            if (deepSeekModalType === 0) {
                this.callDeepSeekAPI(deepSeekModalPatientPart.CONCLUSIONS + '。请根据上述报告结论给出报告解读', 0)
            } else {
                this.callDeepSeekAPI(deepSeekModalPatientPart.CONCLUSIONS + '。我是基层医疗机构医生，请帮我解读上述报告结论，给予基层医疗机构诊疗建议，并写明参考来源', 0)
            }
        })
    }
    showAOrB = () => {
        //AI_EXAM_SUGGEST AI诊疗建议
        //AI_INTERPRETATION报告解读
        const { deepSeekModalType, deepSeekModalPatientPart } = this.props
        if (deepSeekModalType === 0) {
            if (deepSeekModalPatientPart.AI_INTERPRETATION || this.state.AIRequestType === 3) {
                // return <div style={{ padding: '4px 11px' }}>{deepSeekModalPatientPart.AI_INTERPRETATION}</div>
                return <ReactMarkdown>{deepSeekModalPatientPart.AI_INTERPRETATION || this.state.contentAnswer}</ReactMarkdown>
            } else {
                if (this.state.AIRequestType === 0) {
                    return <Spin
                        tip='报告解读中，请稍后'
                        size="large"
                        className='AISpin'
                    />
                } else if (this.state.AIRequestType === 1) {//AI生成完毕
                    return <div id='responseWrite'></div>
                } else if (this.state.AIRequestType === 2) {//AI生成失败
                    return <div className='loswerPart'>
                        <div className='loswerCicle'>+</div>
                        <p>报告解读失败，请重试</p>
                        <Button className='tryAgain' onClick={this.tryAgain}>重试</Button>
                    </div>
                }
            }

        } else {
            if (deepSeekModalPatientPart.AI_EXAM_SUGGEST || this.state.AIRequestType === 3) {
                return <ReactMarkdown>{deepSeekModalPatientPart.AI_EXAM_SUGGEST || this.state.contentAnswer}</ReactMarkdown>
            } else {
                if (this.state.AIRequestType === 0) {
                    return <Spin
                        tip='诊疗建议回复中，请稍后'
                        size="large"
                        className='AISpin'
                    />
                } else if (this.state.AIRequestType === 1) {//AI生成完毕
                    return <div id='responseWrite'></div>
                } else if (this.state.AIRequestType === 2) {//AI生成失败
                    return <div className='loswerPart'>
                        <div className='loswerCicle'>+</div>
                        <p>建议回复超时，请重试</p>
                        <Button className='tryAgain' onClick={this.tryAgain}>重试</Button>
                    </div>
                }
            }
        }

    }
    showPaintPart = () => {
        const { deepSeekModalType, deepSeekModalPatientPart, } = this.props
        const { contentAnswer } = this.state
        if (deepSeekModalType === 0) {
            return <ReactMarkdown>{deepSeekModalPatientPart.AI_INTERPRETATION ? deepSeekModalPatientPart.AI_INTERPRETATION : contentAnswer}</ReactMarkdown>
        } else {
            return <ReactMarkdown>{deepSeekModalPatientPart.AI_EXAM_SUGGEST ? deepSeekModalPatientPart.AI_EXAM_SUGGEST : contentAnswer}</ReactMarkdown>
        }

    }
    //打印部分做分页处理
    openPaintPage = () => {
        //处理后续逻辑
        let paintModalFirst = document.getElementById("paintModalFirst")
        //判断当前渲染的页面是否超过a4纸的高度，超过需要做分页处理，否则直接打印a4纸297mm在常规分辨率下对应1122.66px，可以直接四舍五入为1123
        //取AI结果距离视口上边距
        const divAIAnswerTitle = document.getElementById("AIAnswerTitle");
        const divAIAnswerTitleTop = divAIAnswerTitle.getBoundingClientRect().top;
        //a4纸总高度-ai标题距离的视口的上边距-本身标题高度-ai内容部分的padding高度-整张a4纸下边部分的padding高度；得出ai区域的可用高度
        let aiPartHeightFirstPager = 1123 - divAIAnswerTitleTop - 27 - 25 - 25

        const AIAnswerContent = document.getElementById('AIAnswerContent');
        const childrenAIAnswerContent = AIAnswerContent.children;

        const detaileViewAll = document.getElementById("detaileViewAll")
        //建好的两个隐藏模板打印页面，直接取来用，给answer结果往里边塞即可
        const templateFirstPage = document.getElementById("templateFirstPage")
        const newElement = templateFirstPage.cloneNode(true); // 深度克隆
        newElement.style.display = ""
        detaileViewAll.appendChild(newElement)
        let detaileViewAllChildren = detaileViewAll.children;
        let detaileViewItemChildren = detaileViewAllChildren[0].children
        let detaileViewItemAIAnsterContent = detaileViewItemChildren[7]

        let AIAnswerContentAffterDelete = AIAnswerContent.cloneNode(true)
        let AIAnswerContentAffterDeleteArr = AIAnswerContentAffterDelete.children;
        let currentIndex = 0//删除多少个了
        for (let i = 0; i < childrenAIAnswerContent.length; i++) {
            let pushItem = AIAnswerContentAffterDeleteArr[0].cloneNode(true)
            detaileViewItemAIAnsterContent.appendChild(pushItem)
            //此处要去掉padding高度
            let clientHeightAi = detaileViewItemAIAnsterContent.clientHeight - 25
            //判断是否超长，不超长写一段删一段，超长再另行处理
            if (clientHeightAi > aiPartHeightFirstPager) {
                //超长时需要一行一行累加
                detaileViewItemAIAnsterContent.removeChild(detaileViewItemAIAnsterContent.children[i])
                this.deepPageTurnDataHandle(pushItem, detaileViewItemAIAnsterContent, i, aiPartHeightFirstPager, 0, clientHeightAi)
                break;
            } else {
                currentIndex = i
                AIAnswerContentAffterDelete.removeChild(AIAnswerContentAffterDelete.children[0])
            }
        }
        //创建一行div，加页码
        let pageNoDiv = document.createElement('div');
        pageNoDiv.textContent = '1';
        pageNoDiv.style.position = "absolute"
        pageNoDiv.style.bottom = "15px"
        pageNoDiv.style.left = "0px"
        pageNoDiv.style.width = "100%"
        pageNoDiv.style.display = "flex"
        pageNoDiv.style.justifyContent = "center"
        pageNoDiv.style.alignItems = "center"
        detaileViewAllChildren[0].appendChild(pageNoDiv)
        if (paintModalFirst.offsetHeight > 1123) {
            // 去打印第二页
            this.deepCreatSecondPageAgain(childrenAIAnswerContent, AIAnswerContentAffterDelete, AIAnswerContentAffterDeleteArr, currentIndex, 2)
        }
    }
    //写一个递归，处理翻页时的分页数据pushItem需要推送的数据、detaileViewItemAIAnsterContent容器、aiPartHeight第一页ai部分允许高度，currentIndex当前pushItem中第几个子集，push之后的内容高度
    //自己被分页分割时，一个一个添加子集的子集
    deepPageTurnDataHandle = (pushItem, detaileViewItemAIAnsterContent, detaileViewItemAIAnsterContentIndex, aiPartHeight, currentIndex, clientHeightAi) => {
        let newitem = pushItem.cloneNode(true); // 深度克隆
        if (pushItem.children.length === 1 || pushItem.children.length === 0) {
            //如果被分页分割的dom，只有一个子集或者0个子集，要删除分割数据的标识
            localStorage.removeItem("firstPageTurnmarkSon")
            return
        } else {
            if (currentIndex === 0) {
                const elementType = pushItem.nodeName; // 或 element.tagName
                const newElement = document.createElement(elementType);
                newElement.appendChild(newitem.children[currentIndex])
                detaileViewItemAIAnsterContent.appendChild(newElement)
            } else {
                detaileViewItemAIAnsterContent.children[detaileViewItemAIAnsterContentIndex].appendChild(newitem.children[currentIndex])
            }
            clientHeightAi = detaileViewItemAIAnsterContent.clientHeight - 25
            if (clientHeightAi > aiPartHeight) {
                //content子集下的子集出现超长的index
                localStorage.setItem("firstPageTurnmarkSon", currentIndex)
                const lastChild = detaileViewItemAIAnsterContent.children[detaileViewItemAIAnsterContentIndex].lastElementChild
                lastChild.remove();
                return

            } else {
                currentIndex++
                this.deepPageTurnDataHandle(pushItem, detaileViewItemAIAnsterContent, detaileViewItemAIAnsterContentIndex, aiPartHeight, currentIndex, clientHeightAi)
            }
        }
    }
    //写一个递归，直到剩余内容打印完，否则就会创建模板页，两页是没问题的，多页没试
    deepCreatSecondPageAgain = (childrenAIAnswerContent, AIAnswerContentAffterDelete, AIAnswerContentAffterDeleteArr, currentIndex, pageNum) => {
        if (AIAnswerContentAffterDeleteArr.length === 0) {
            return
        }
        //取报告结论距离视口上边距
        const divConclusionTitle = document.getElementById("conclusionTitle");
        const divConclusionTitleTop = divConclusionTitle.getBoundingClientRect().top;
        let aiPartHeightSecondPager = 1123 - divConclusionTitleTop - 27 - 25 - 25
        const detaileViewAll = document.getElementById("detaileViewAll")
        //建好的两个隐藏模板打印页面，直接取来用，给answer结果往里边塞即可
        const templateSecondPage = document.getElementById("templateSecondPage")
        const newElement = templateSecondPage.cloneNode(true); // 深度克隆
        newElement.style.display = ""
        detaileViewAll.appendChild(newElement)
        let detaileViewAllChildren = detaileViewAll.children;
        let detaileViewItemChildren = detaileViewAllChildren[pageNum - 1].children
        let detaileViewItemAIAnsterContent = detaileViewItemChildren[5]
        let isFirstCycle = true//每页是不是第一次循环
        for (let i = currentIndex; i < childrenAIAnswerContent.length; i++) {
            if (AIAnswerContentAffterDeleteArr.length === 0) {
                break
            }
            let pushItem
            //分页之后要处理第一次循环
            if (isFirstCycle) {
                pushItem = AIAnswerContentAffterDeleteArr[0].cloneNode(true)
                let count = parseInt(localStorage.getItem("firstPageTurnmarkSon"));
                while (count-- && pushItem.firstElementChild) {
                    pushItem.removeChild(pushItem.firstElementChild);
                }
                detaileViewItemAIAnsterContent.appendChild(pushItem)
            } else {
                pushItem = AIAnswerContentAffterDeleteArr[0].cloneNode(true)
                detaileViewItemAIAnsterContent.appendChild(pushItem)
            }
            let clientHeightAi = detaileViewItemAIAnsterContent.clientHeight
            //判断是否超长，不超长写一段删一段，超长再另行处理
            if (clientHeightAi > aiPartHeightSecondPager) {
                //如果出现子集下边有超过一个的集合，删除最后一项，到第二页处理
                detaileViewItemAIAnsterContent.removeChild(detaileViewItemAIAnsterContent.children[i])
                //如果超长处理被分割的数据
                this.deepPageTurnDataHandle(pushItem, detaileViewItemAIAnsterContent, i, aiPartHeightSecondPager, 0, clientHeightAi)
                //如果超长，打印后边一页
                this.deepCreatSecondPageAgain(childrenAIAnswerContent, AIAnswerContentAffterDelete, AIAnswerContentAffterDeleteArr, currentIndex, pageNum++)
                break;
            } else {
                currentIndex = i
                AIAnswerContentAffterDelete.removeChild(AIAnswerContentAffterDelete.children[0])
            }
            isFirstCycle = false
        }
        //创建一行div，加页码
        let pageNoDiv = document.createElement('div');
        pageNoDiv.textContent = pageNum;
        pageNoDiv.style.position = "absolute"
        pageNoDiv.style.bottom = "15px"
        pageNoDiv.style.left = "0px"
        pageNoDiv.style.width = "100%"
        pageNoDiv.style.display = "flex"
        pageNoDiv.style.justifyContent = "center"
        pageNoDiv.style.alignItems = "center"
        detaileViewAllChildren[pageNum - 1].appendChild(pageNoDiv)
    }
    paintResult = () => {
        if (this.state.AIRequestType === 3) {
            setTimeout(() => {
                downloadPDF(this.paintRef, 1);
            }, 1000);
        } else {
            message.warn("AI解读未完成，请稍后")
        }
    }
    render() {
        const { visible, deepSeekModalPatientPart, deepSeekModalType, } = this.props
        return (
            <div>
                <Modal
                    visible={visible}
                    width="1020px"
                    className="addPatientWrap"
                    title={
                        <div className="patient_title">
                            <img alt="" src={require("@/assets/image/ecg.png").default} className="addIcon" />
                            <span>{deepSeekModalType === 0 ? '报告解读' : '诊疗建议'}</span>
                        </div>
                    }
                    footer={null}
                    onCancel={this.handleCancel}
                    zIndex={9}
                >
                    <div className='AIPart1'>
                        <p>患者姓名：{deepSeekModalPatientPart.NAME}</p>
                        <p>性别：{deepSeekModalPatientPart.SEX_NAME}</p>
                        <p>年龄：{deepSeekModalPatientPart.AgeDisPlay ? deepSeekModalPatientPart.AgeDisPlay : (deepSeekModalPatientPart.EXAM_AGE + deepSeekModalPatientPart.AGE_UNIT)}</p>
                        <p>联系电话：{deepSeekModalPatientPart.CONTACT_TEL}</p>
                        <p>身份证号：{deepSeekModalPatientPart.ID_NUMBER}</p>
                    </div>
                    <Divider></Divider>
                    <p className='AIPart2P'>报告结论：</p>
                    <TextArea
                        className='AIPart2TextArea'
                        name="TextArea"
                        value={deepSeekModalPatientPart.CONCLUSIONS}
                        autoSize={{ minRows: 5, maxRows: 5 }}
                        disabled
                        style={{
                            height: 125,
                            resize: 'none',
                        }}
                    />
                    <p className='AIPart2P' style={{ marginTop: '20px' }}>{deepSeekModalType === 0 ? '报告解读：' : '诊疗建议：'}</p>
                    <div className='AIAnwer' id='AIAnwer'>
                        {this.showAOrB()}
                    </div>
                    <div className='AIfooter'>
                        <p>&nbsp;</p>
                        <p>
                            <Button className='AIButton' onClick={this.paintResult} style={{ marginRight: "10px" }}>打印</Button>
                            <Button className='AIButton' onClick={this.handleCancel}>关闭</Button>
                        </p>
                        <p style={{ textAlign: 'right', marginRight: '20px' }}>注：以上内容由DeepSeek AI大模型提供，仅供参考</p>
                    </div>
                </Modal>
                {/* 预加载的打印层 */}
                {visible ? (
                    <Modal
                        visible={visible}
                        width="100%"
                        zIndex={-1}
                        style={{ top: "0px", padding: "0px" }}
                        footer={false}
                        className='deepSeekModal'
                    >
                        <div className="paintModal" id="paintModalFirst">
                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                <div className='detaileView'
                                    // 210mm=793.7007874px; 297mm=1122.66px，用的时候四舍五入即可
                                    style={{
                                        width: 210 + 'mm',
                                        color: '#000',
                                        padding: '25px 30px',
                                        position: "relative"
                                    }}>
                                    <div style={{ width: "100%", textAlign: "center", fontSize: "28px", fontWeight: "bold" }}>
                                        {deepSeekModalType === 0 ? '报告解读' : '诊疗建议'}
                                    </div>
                                    <div style={{ textAlign: "right" }}>
                                        {/* ECG Holter BloodPressure */}
                                        检查项目：{deepSeekModalPatientPart.EXAM_CLASS === "ECG" ? "静息心电" : deepSeekModalPatientPart.EXAM_CLASS === "Holter" ? "动态心电" : "动态血压"}
                                    </div>
                                    <div style={{ fontSize: "18px", backgroundColor: "#f0f0f0", paddingLeft: "10px", marginTop: "10px" }}>
                                        患者信息
                                    </div>
                                    <div style={{ paddingLeft: "10px", overflow: "hidden" }}>
                                        <ul>
                                            <li style={{ width: "33.3%", float: 'left', paddingTop: "10px" }}>
                                                患者姓名：{deepSeekModalPatientPart.NAME}
                                            </li>
                                            <li style={{ width: "33.3%", float: 'left', paddingTop: "10px" }}>
                                                年龄：{deepSeekModalPatientPart.AgeDisPlay ? deepSeekModalPatientPart.AgeDisPlay : (deepSeekModalPatientPart.EXAM_AGE + deepSeekModalPatientPart.AGE_UNIT)}
                                            </li>
                                            <li style={{ width: "33.3%", float: 'left', paddingTop: "10px" }}>
                                                联系电话：{deepSeekModalPatientPart.CONTACT_TEL}
                                            </li>
                                            <li style={{ width: "33.3%", float: 'left', paddingTop: "10px" }}>
                                                身份证号：{deepSeekModalPatientPart.ID_NUMBER}
                                            </li>
                                            <li style={{ width: "33.3%", float: 'left', paddingTop: "10px" }}>
                                                性别：{deepSeekModalPatientPart.SEX_NAME}
                                            </li>
                                        </ul>
                                    </div>
                                    <div id="conclusionTitle" style={{ fontSize: "18px", backgroundColor: "#f0f0f0", paddingLeft: "10px", clear: "both", marginTop: "15px" }}>
                                        报告结论
                                    </div>
                                    <div style={{ color: "#000", border: "none", width: "100%", minWidth: "100px", whiteSpace: 'pre-line', padding: "5px 10px" }}>
                                        {this.state.aaa}
                                    </div>
                                    <div id="AIAnswerTitle" style={{ fontSize: "18px", backgroundColor: "#f0f0f0", paddingLeft: "10px", clear: "both", marginTop: "15px" }}>
                                        {deepSeekModalType === 0 ? '报告解读' : '诊疗建议'}
                                    </div>
                                    <div id="AIAnswerContent" style={{ padding: "5px 10px 20px 10px" }}>
                                        {this.showPaintPart()}
                                    </div>
                                    <div style={{ position: "absolute", bottom: "15px", right: "0px" }}>
                                        <p style={{ textAlign: 'right', marginRight: '20px', fontSize: "12px" }}>注：以上内容由DeepSeek AI大模型提供，仅供参考</p>
                                    </div>
                                </div>
                                <div className='detaileViewAll' id="detaileViewAll"
                                    ref={this.paintRef}
                                >
                                </div>
                                {/* 打印模板部分 */}
                                <>
                                    <div
                                        id='templateFirstPage'
                                        style={{
                                            width: "210mm",
                                            height: "297mm",
                                            color: '#000',
                                            padding: '25px 30px',
                                            position: "relative",
                                            display: "none"
                                        }}
                                    >
                                        <div style={{ width: "100%", textAlign: "center", fontSize: "28px", fontWeight: "bold" }}>
                                            {deepSeekModalType === 0 ? '报告解读' : '诊疗建议'}
                                        </div>
                                        <div style={{ textAlign: "right" }}>
                                            检查项目：{deepSeekModalPatientPart.EXAM_CLASS === "ECG" ? "静息心电" : deepSeekModalPatientPart.EXAM_CLASS === "Holter" ? "动态心电" : "动态血压"}
                                        </div>
                                        <div style={{ fontSize: "18px", backgroundColor: "#f0f0f0", paddingLeft: "10px", marginTop: "10px" }}>
                                            患者信息
                                        </div>
                                        <div style={{ paddingLeft: "10px", overflow: "hidden" }}>
                                            <ul>
                                                <li style={{ width: "33.3%", float: 'left', paddingTop: "10px" }}>
                                                    患者姓名：{deepSeekModalPatientPart.NAME}
                                                </li>
                                                <li style={{ width: "33.3%", float: 'left', paddingTop: "10px" }}>
                                                    年龄：{deepSeekModalPatientPart.AgeDisPlay ? deepSeekModalPatientPart.AgeDisPlay : (deepSeekModalPatientPart.EXAM_AGE + deepSeekModalPatientPart.AGE_UNIT)}
                                                </li>
                                                <li style={{ width: "33.3%", float: 'left', paddingTop: "10px" }}>
                                                    联系电话：{deepSeekModalPatientPart.CONTACT_TEL}
                                                </li>
                                                <li style={{ width: "33.3%", float: 'left', paddingTop: "10px" }}>
                                                    身份证号：{deepSeekModalPatientPart.ID_NUMBER}
                                                </li>
                                                <li style={{ width: "33.3%", float: 'left', paddingTop: "10px" }}>
                                                    性别：{deepSeekModalPatientPart.SEX_NAME}
                                                </li>
                                            </ul>
                                        </div>
                                        <div style={{ fontSize: "18px", backgroundColor: "#f0f0f0", paddingLeft: "10px", clear: "both", marginTop: "15px" }}>
                                            报告结论
                                        </div>
                                        <div style={{ color: "#000", border: "none", width: "100%", minWidth: "100px", whiteSpace: 'pre-line', padding: "5px 10px" }}>
                                            {this.state.aaa}
                                        </div>
                                        <div style={{ fontSize: "18px", backgroundColor: "#f0f0f0", paddingLeft: "10px", clear: "both", marginTop: "15px" }}>
                                            {deepSeekModalType === 0 ? '报告解读' : '诊疗建议'}
                                        </div>
                                        <div style={{ padding: "5px 10px 20px 10px" }}>

                                        </div>
                                        <div style={{ position: "absolute", bottom: "15px", right: "0px" }}>
                                            <p style={{ textAlign: 'right', marginRight: '20px', fontSize: "12px" }}>注：以上内容由DeepSeek AI大模型提供，仅供参考</p>
                                        </div>
                                    </div>
                                    <div
                                        id='templateSecondPage'
                                        style={{
                                            width: "210mm",
                                            height: "297mm",
                                            color: '#000',
                                            padding: '25px 30px',
                                            position: "relative",
                                            display: "none"
                                        }}
                                    >
                                        <div style={{ width: "100%", textAlign: "center", fontSize: "28px", fontWeight: "bold" }}>
                                            {deepSeekModalType === 0 ? '报告解读' : '诊疗建议'}
                                        </div>
                                        <div style={{ textAlign: "right" }}>
                                            检查项目：{deepSeekModalPatientPart.EXAM_CLASS === "ECG" ? "静息心电" : deepSeekModalPatientPart.EXAM_CLASS === "Holter" ? "动态心电" : "动态血压"}
                                        </div>
                                        <div style={{ fontSize: "18px", backgroundColor: "#f0f0f0", paddingLeft: "10px", marginTop: "10px" }}>
                                            患者信息
                                        </div>
                                        <div style={{ paddingLeft: "10px", overflow: "hidden" }}>
                                            <ul>
                                                <li style={{ width: "33.3%", float: 'left', paddingTop: "10px" }}>
                                                    患者姓名：{deepSeekModalPatientPart.NAME}
                                                </li>
                                                <li style={{ width: "33.3%", float: 'left', paddingTop: "10px" }}>
                                                    年龄：{deepSeekModalPatientPart.AgeDisPlay ? deepSeekModalPatientPart.AgeDisPlay : (deepSeekModalPatientPart.EXAM_AGE + deepSeekModalPatientPart.AGE_UNIT)}
                                                </li>
                                                <li style={{ width: "33.3%", float: 'left', paddingTop: "10px" }}>
                                                    联系电话：{deepSeekModalPatientPart.CONTACT_TEL}
                                                </li>
                                                <li style={{ width: "33.3%", float: 'left', paddingTop: "10px" }}>
                                                    身份证号：{deepSeekModalPatientPart.ID_NUMBER}
                                                </li>
                                                <li style={{ width: "33.3%", float: 'left', paddingTop: "10px" }}>
                                                    性别：{deepSeekModalPatientPart.SEX_NAME}
                                                </li>
                                            </ul>
                                        </div>
                                        <div style={{ fontSize: "18px", backgroundColor: "#f0f0f0", paddingLeft: "10px", clear: "both", marginTop: "15px" }}>
                                            {deepSeekModalType === 0 ? '报告解读' : '诊疗建议'}
                                        </div>
                                        <div style={{ padding: "5px 10px 20px 10px" }}>

                                        </div>
                                        <div style={{ position: "absolute", bottom: "15px", right: "0px" }}>
                                            <p style={{ textAlign: 'right', marginRight: '20px', fontSize: "12px" }}>注：以上内容由DeepSeek AI大模型提供，仅供参考</p>
                                        </div>
                                    </div>
                                </>
                            </div>
                        </div>
                    </Modal>
                ) : null}
            </div>
        )
    }
}

export default DeepSeekModal;